import { lazy, Suspense, useEffect } from 'react';

import { useQueries } from '@tanstack/react-query';
import { Route, Routes } from 'react-router';

import { LoadingScreen, ProtectedRoute } from '@/components';
import { LEAGUE_KEY } from '@/constants';
import { useBusinessData, useIsAdminRole } from '@/hooks';
import { TabsLayout } from '@/layouts';
import { cuInfoQuery, paywallQuery } from '@/query';
import { APP_ROUTES } from '@/routes';
import { AppDataQueryResult } from '@/types';

const NotFoundPage = lazy(() => import('@/pages/Page404'));

export function Router() {
  const { isAdmin } = useIsAdminRole();
  const { setCUData, setIsLeague } = useBusinessData();

  const resultData = useQueries({
    queries: [paywallQuery(), cuInfoQuery()],
  }) as AppDataQueryResult;

  const [{ data: paywallData }, { data: cuInfoData }] = resultData;

  useEffect(() => {
    if (cuInfoData) {
      setCUData(cuInfoData.result);
      setIsLeague(LEAGUE_KEY === cuInfoData.result.organisationType);
    }
  }, [cuInfoData, setCUData, setIsLeague]);

  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route
          path={APP_ROUTES.aires}
          element={
            <ProtectedRoute paywallData={paywallData}>
              <TabsLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.loansMapping}
          element={
            <ProtectedRoute paywallData={paywallData}>
              <TabsLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.loansUploadMapping}
          element={
            <ProtectedRoute paywallData={paywallData}>
              <TabsLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.sharesMapping}
          element={
            <ProtectedRoute paywallData={paywallData}>
              <TabsLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.sharesUploadMapping}
          element={
            <ProtectedRoute paywallData={paywallData}>
              <TabsLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.codeMapping}
          element={
            <ProtectedRoute paywallData={paywallData}>
              <TabsLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.codeUploadMapping}
          element={
            <ProtectedRoute paywallData={paywallData}>
              <TabsLayout />
            </ProtectedRoute>
          }
        />
        {isAdmin && (
          <Route
            path={APP_ROUTES.uploadHistory}
            element={
              <ProtectedRoute paywallData={paywallData}>
                <TabsLayout />
              </ProtectedRoute>
            }
          />
        )}
        <Route path={APP_ROUTES.catchAll} element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
